module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Regular-Hestia.227c062.eot";